import { merge } from "lodash";

import { generalTranslations } from "../../general.js";
import { modalsCommon, modalsChangePassword } from "../../modals.js";
export default merge(generalTranslations, modalsCommon, modalsChangePassword);
